import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import { App } from 'antd';

import { ApiKeysForm } from '../components/ApiKeysForm';
import { Save } from '../../../widgets/Save';
import { initialValues, validationSchema } from '../utils/fields';
import { useCreateFeedMutation } from '../../feed/service/feed.api';
import { ApiKeysDTO } from '../service/apiKeys.interface';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../shops/store/shopSlice';
import { useFeed } from '../../feed/hooks/useFeed';
import { FeedResponseProps } from '../../feed/service/feed.interface';

export const ApiKeysEditContainer = () => {
    const { id, type } = useAppSelector(selectShopCurrent);
    const { notification } = App.useApp();

    const [createFeed, { isSuccess, isLoading }] = useCreateFeedMutation();

    const { data } = useFeed();

    useEffect(() => {
        if (isSuccess) {
            notification.success({
                message: 'Успешно сохранено',
            });
        }
    }, [isSuccess]);
    const onSubmit = async (values: ApiKeysDTO) => {
        const filteredValues = Object.fromEntries(
            Object.entries(values).filter(([_, v]) => v !== null && v !== '')
        );

        const typeMap: Record<number, number> = {
            1: 8,
            2: 10,
        };

        const payload = {
            id,
            type: typeMap[type],
            ...filteredValues,
        };

        await createFeed(payload);
    };

    const interceptInitial = (values: Partial<FeedResponseProps>) => {
        return {
            ...values,
            api_key: values.api_key ? '**********' : '',
        };
    };

    const formik = useFormik({
        initialValues:
            data !== undefined ? interceptInitial(data) : initialValues,
        validationSchema,
        onSubmit: onSubmit,
        validateOnChange: true,
        validateOnBlur: true,
        validateOnMount: false,
        enableReinitialize: true,
    });

    useEffect(() => {
        if (formik.values.client_id !== formik.initialValues.client_id) {
            formik.setFieldValue('api_key', '');
        }
    }, [formik.values.client_id, formik.initialValues.client_id]);

    return (
        <>
            <ApiKeysForm formik={formik} />
            <Save
                onSave={formik.submitForm}
                disabled={
                    !formik.isValid || !formik.dirty || formik.isSubmitting
                }
                loading={isLoading}
            />
        </>
    );
};
